exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}.edit-search-console__header{display:flex;align-items:center;justify-content:space-between}.edit-search-console__header span{color:#49a74c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/containers/editSearchConsoleContainer.scss
// module id = 1345
// module chunks = 0